import { z, type ZodTypeAny } from 'zod'

/**
 * 範例：{ a : { b : { view:true } } }
 */

export function getPermissionDataSchema<T extends ZodTypeAny>(value: T) {
  return z.record(z.string(), z.record(z.record(value, z.boolean())))
}
